import { render, staticRenderFns } from "./AmountTextField.vue?vue&type=template&id=4979e35f&"
import script from "./AmountTextField.vue?vue&type=script&lang=js&"
export * from "./AmountTextField.vue?vue&type=script&lang=js&"
import style0 from "./AmountTextField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports